import { makeStyles } from "@material-ui/core/styles";
import {
  secondary,
  grey300,
  error,
  success,
} from "../../../assets/variables.module.scss";

const useStyles = makeStyles((theme) => ({
  spinner: {
    color: secondary,
    margin: theme.spacing(4),
  },
  requestTypeContainer: {
    paddingBottom: theme.spacing(6),
  },
  typeTitleContainer: {
    paddingBottom: theme.spacing(2),
  },
  requestContainer: {
    padding: theme.spacing(1),
    borderBottom: `1px solid ${grey300}`,
    marginBottom: theme.spacing(1),
  },
  fileIcon: {
    color: secondary,
  },
  requestTitle: {
    paddingBottom: theme.spacing(2),
  },
  approvalIcon: {
    width: theme.spacing(2),
    marginRight: theme.spacing(1),
  },
  approvedIcon: {
    color: success,
  },
  rejectedIcon: {
    color: error,
  },
  emptyListContainer: {
    "& svg": {
      height: 100,
    },
  },
}));

export default useStyles;
